import React from "react";
import { inScale } from "../../lib/scaleCountry";
import { playTone } from "../../lib/scaleCountryAudio";

/* ============================================================
   ScaleKeyboard — one C→C octave, greyed out wherever the
   current scale doesn't have a note. Root keys (C at each end)
   get a green inset stripe so the "home" note reads at a glance.
   ============================================================ */

const WHITE_KEYS = [
  { offset: 0, label: "C" },
  { offset: 2, label: "D" },
  { offset: 4, label: "E" },
  { offset: 5, label: "F" },
  { offset: 7, label: "G" },
  { offset: 9, label: "A" },
  { offset: 11, label: "B" },
  { offset: 12, label: "C" },
];

// Black keys sit on the seam between two white keys. `whiteIndex` is the
// white key to their right, so left = whiteIndex * 52 - 16 centers the
// 32px-wide black key on that seam.
const BLACK_KEYS = [
  { offset: 1, label: "C#" },
  { offset: 3, label: "D#" },
  { offset: 6, label: "F#" },
  { offset: 8, label: "G#" },
  { offset: 10, label: "A#" },
];
const BLACK_WHITE_INDEX = { 1: 1, 3: 2, 6: 4, 8: 5, 10: 6 };

const WHITE_W = 52;
const BLACK_W = 32;
const BLACK_H = 92;
const HEIGHT = 150;

const ScaleKeyboard = ({ semis, rootMidi = 60, onNote }) => {
  const strike = (offset) => {
    const midi = rootMidi + offset;
    playTone(midi, { durMs: 600, gain: 0.15 });
    onNote?.(midi);
  };

  return (
    <div className="relative" style={{ width: WHITE_W * 8, height: HEIGHT }}>
      {WHITE_KEYS.map(({ offset, label }, i) => {
        const active = inScale(semis, offset);
        const isRoot = offset === 0 || offset === 12;
        return (
          <button
            key={`w-${i}`}
            type="button"
            aria-label={`${label} key`}
            disabled={!active}
            onPointerDown={() => strike(offset)}
            className={`absolute top-0 flex items-end justify-center rounded-b-md border border-[#45523F] bg-[#F2F4E4] pb-2 font-mono text-xs text-[#55603F] transition-colors active:bg-[#A6C46A] ${
              active ? "" : "pointer-events-none opacity-20"
            }`}
            style={{
              left: i * WHITE_W,
              width: WHITE_W,
              height: HEIGHT,
              boxShadow: isRoot ? "inset 0 -5px 0 #A6C46A" : undefined,
            }}
          >
            {active ? label : ""}
          </button>
        );
      })}
      {BLACK_KEYS.map(({ offset, label }) => {
        const active = inScale(semis, offset);
        return (
          <button
            key={`b-${offset}`}
            type="button"
            aria-label={`${label} key`}
            disabled={!active}
            onPointerDown={() => strike(offset)}
            className={`absolute top-0 z-10 rounded-b-md border border-[#10140D] bg-[#10140D] ${
              active ? "" : "pointer-events-none opacity-20"
            }`}
            style={{
              left: BLACK_WHITE_INDEX[offset] * WHITE_W - BLACK_W / 2,
              width: BLACK_W,
              height: BLACK_H,
            }}
          />
        );
      })}
    </div>
  );
};

export default ScaleKeyboard;
